import React from "react";
import Alert from "@amzn/meridian/alert";
import Toaster from "@amzn/meridian/toaster";
import { FormattedMessage } from "react-intl";
import { TOAST_NOTIFICATION_LEVELS } from "../constants/Constants";

const ToasterComponent = ({ toasts, onCloseToast }) => {
  return (
    <Toaster
      toasts={toasts}
      onCloseToast={onCloseToast}
      alignmentHorizontal="center"
      alignmentVertical="top"
    >
      {(toast) => {
        const alertType = toast.level || TOAST_NOTIFICATION_LEVELS.SUCCESS;
        return (
          <Alert type={alertType} toast={true} onClose={toast.onClose}>
            {toast.messageId ? (
              <FormattedMessage
                id={toast.messageId}
                defaultMessage={toast.defaultMessage}
              />
            ) : (
              toast.message
            )}
          </Alert>
        );
      }}
    </Toaster>
  );
};

export default ToasterComponent;



// WEBPACK FOOTER //
// ./src/components/mySCC/components/ToasterComponent.js